export class DocumentTypeMimeTypes {
  public static PDF(): string[] {
    return ['application/pdf'];
  }

  public static WordProcessor(): string[] {
    return ['application/rtf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  }

  public static SpreadSheet(): string[] {
    return ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
  }

  public static WebImage(): string[] {
    return ['image/png', 'image/jpeg', 'image/pjpeg'];
  }
}
